export default class RequestSortType {
    static DATE = 0;
    static DEADLINE = 1;
    static ACTIVITY = 2;
    static ID = 3;
    static STATUS = 4;
    static AUTHOR = 5;
    static EXECUTOR = 6;
    static SERVICE = 7;
    static CATEGORY = 8;
    static CITY = 9;
    static GROUP = 10;
    static PRIORITY = 11;
}
